






















import Vue from 'vue'
import {mapActions, mapMutations} from 'vuex'
import CercaIndirizzoSearchItem from './CercaIndirizzoSearchItem.vue'

export default Vue.extend({
    data: () => ({
        // questi sono i suggerimenti per l'autocompletamento
        autocompleteItems: [],
        // questo e il componente con la grafica di un suggerimento
        componentItem: CercaIndirizzoSearchItem
    }),
    computed: {
        // variabile collegata allo store dei modal
        // viene usata dalla mappa per sapere quando deve spostare il centro
        indirizzoAutocompletato: {
            get(): object {
                return this.$store.state.modal.indirizzoAutocompletato
            },
            set(value: any) {
                if (value) {
                    this.SET_NUOVE_COORDINATE([parseFloat(value.geoLongitude), parseFloat(value.geoLatitude)])
                }
            }
        }
    },
    methods: {
        ...mapActions('modal', ['showModal']),
        ...mapMutations('modal', ['SET_NUOVE_COORDINATE']),
        // quando si clicca un suggerimento, cosa bisogna mostrare nel input?
        // il titolo ovviamente
        getLabel: (indirizzoAutocompletato) => indirizzoAutocompletato ? indirizzoAutocompletato.title : '',
        // funzione richiamata per aggiornare i suggerimenti
        async updateItems(text) {
            try {
                const response = await Vue.axios.get(`https://home.tecnograph-group.com/geocodermassivo/autocomplete?search_text=${text}&key=mZUatrfF5jAjQ8UB`)
                this.autocompleteItems = response.data
            } catch (err) {
                console.error(err)
            }
        }
    }
})
